import { ActionTypes } from "../../constants";
import { addOrReplace } from "../../utilities/reducers";
import { combineReducers } from "redux";
import activities, * as fromActivities from "./activities";

const reduceJobPlans = (state = [], action) => {
    let jp;
    switch (action.type) {
        case ActionTypes.GET_JP_JOBPLAN_LIST_SUCCESS:
            return action.data;

        case ActionTypes.GET_JP_JOBPLAN_SUCCESS:
            return addOrReplace(state, action.data);

        case ActionTypes.DELETE_JP_JOBPLAN_SUCCESS:
            const jobPlanId = Number(action.payload.id);
            return state.filter(({id}) => Number(id) !== jobPlanId);


        case ActionTypes.ADD_JP_ACTIVITY_SUCCESS:
            jp = state.find(({id}) => id === action.payload.jpId);
            return [
                ...state.filter(({id}) => id !== action.payload.jpId),
                {
                    ...jp,
                    activities: [...jp.activities, action.data]
                }
            ];

        case ActionTypes.UPDATE_JP_ACTIVITY_SUCCESS:
            jp = state.find(({id}) => id === action.payload.jpId);
            return [
                ...state.filter(({id}) => id !== action.payload.jpId),
                {
                    ...jp,
                    activities: [...jp.activities.filter(({id}) => id !== action.payload.id), action.data]
                }
            ];

        case ActionTypes.DELETE_JP_ACTIVITY_SUCCESS:
            jp = state.find(({id}) => id === action.payload.jpId);
            return [
                ...state.filter(({id}) => id !== action.payload.jpId),
                {
                    ...jp,
                    activities: jp.activities.filter(({id}) => id !== action.payload.id)
                }
            ];


        case ActionTypes.LOGOUT:
            return [];

        default:
            return state;
    }
};

const jobPlans = combineReducers({
    jobPlans: reduceJobPlans,
    activities,
});

export default jobPlans;
export const getJobPlans = ({jobPlans}) => jobPlans || [];
export const getJobPlan = ({jobPlans}, jobPlanId) => !jobPlans ? null :  jobPlans.find(({id}) => id === jobPlanId);

export const getActivityCategories = ({activities}) => fromActivities.getCategories(activities);

export const getActivityTypes = ({activities}) => fromActivities.getTypes(activities);
export const getActivityType = ({activities}, id) => fromActivities.getType(activities, id);
export const getActivityTypeByCode = ({activities}, code) => fromActivities.getTypeByCode(activities, code);

export const getActivityLocations = ({activities}) => fromActivities.getLocations(activities);
export const getActivityObjectives = ({activities}) => fromActivities.getObjectives(activities);
